import {
  CAMPAIGN_ENUM_TYPES_TO_TITLE,
  CAMPAIGN_TYPE_PARAM_TO_TITLE,
  CAMPAIGN_TYPE_PARAM_TO_CAMPAIGN_NAME,
  CAMPAIGN_SUBTYPES_ENUM,
  CAMPAIGN_ENUM_TYPES,
  CAMPAIGN_DASHBOARD_BY_CAMPAIGN_TYPE,
  CAMPAIGN_TYPES_TO_ENUM_MAP,
} from '../../shared/constants'

export const getBaseCampaignName = (selectedChannel, type, subType) => {
  const isChannel = typeof selectedChannel === 'string'
  const titleKey = subType ? subType : type
  const subTypeEnum = subType ? subType.toUpperCase() : null
  const isAdm = subTypeEnum === CAMPAIGN_SUBTYPES_ENUM.ADM

  if (isAdm) {
    return CAMPAIGN_TYPE_PARAM_TO_CAMPAIGN_NAME[titleKey]
  }

  const channel = isChannel
    ? CAMPAIGN_ENUM_TYPES_TO_TITLE[selectedChannel]
    : !!CAMPAIGN_ENUM_TYPES_TO_TITLE[titleKey]
    ? CAMPAIGN_ENUM_TYPES_TO_TITLE[titleKey]
    : CAMPAIGN_TYPE_PARAM_TO_TITLE[titleKey]
  return channel
}

export const getCampaignDashboardUrl = campaign => {
  if (!campaign || !campaign.type) return 'overview'
  const { type, subtype } = campaign

  if (subtype) {
    return CAMPAIGN_DASHBOARD_BY_CAMPAIGN_TYPE[subtype]
  }

  if (Number.isInteger(type)) {
    return CAMPAIGN_DASHBOARD_BY_CAMPAIGN_TYPE[CAMPAIGN_TYPES_TO_ENUM_MAP[type]]
  }

  return CAMPAIGN_DASHBOARD_BY_CAMPAIGN_TYPE[type]
}

export const isExternalDistributorCampaign = type => {
  // type could be a subtype or a type
  return [
    CAMPAIGN_SUBTYPES_ENUM.ADM,
    CAMPAIGN_SUBTYPES_ENUM.EDDM,
    CAMPAIGN_ENUM_TYPES.INSERTS,
  ].includes(type)
}
